import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import WaitingIcon from './WaitingIcon';
import { requestIcon } from '../constants';

const RequestCardExtra = ({ allowTransfer, request }) => (
  <Card.Content extra>
    <FormattedMessage id={requestIcon(request, allowTransfer).verbose} />
    {request.waiting && <WaitingIcon className="ml-5 mt-5" />}
  </Card.Content>
);

export default RequestCardExtra;
